// WHAT CAN BE CHANGED?
// Change the stream inside the #radioplayer__data-div
// Enter the programming inside radio-programming.json and add the corresponding covers under assets/radioplayer
// You can also make style changes accordingly

<template>
    <div id="radioplayer" v-on:click="gotoListen()" v-bind:class="$route.name === 'Listen' ? 'listen-on-page' : ''">
        <div id="radioplayer__data">
            <audio src="https://stream.rtvparkstad.nl/rtvparkstad.mp3" id="radioplayer__data__stream"></audio>
            <div id="radioplayer__data__cover" v-bind:style="{ 'background-image': 'url(' + cover + ')' }"/>
            <div id="radioplayer__data__labels">
                <div id="radioplayer__data__labels__title">{{ title }}</div>
                <div id="radioplayer__data__labels__name">{{ name }}</div>
            </div>
            <div id="radioplayer__data__button-container">
                <button @click.stop="playPause" class="icon-play"></button>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import json from "@/assets/radioplayer/radio-programming.json"

export default {
    name: "RadioPlayer",
    data() {
        return {
            now: Date.now(),
            cover: null,
            title: null,
            name: null,
        }
    },
    mounted() {
        this.returnEventInformation()
        let self = this
        setInterval(function() {
            self.now = Date.now()
            self.returnEventInformation()
        }, 60000)
    },
    methods: {
        playPause() {
            let audio = $("audio")[0];
            if (audio.paused) {
                audio.load()
                audio.play();
                $("#radioplayer__data__button-container button").removeClass("icon-play");
                $("#radioplayer__data__button-container button").addClass("icon-pause");
            } else {
                audio.pause();
                $("#radioplayer__data__button-container button").removeClass("icon-pause");
                $("#radioplayer__data__button-container button").addClass("icon-play");
            }
        },
        gotoListen() {
            this.$router.push("/listen");
        },
        returnEventInformation() {
            const date = new Date(this.now)
            for (let i = 0; i < json.programming.length; i++) {
                if (i == date.getDay()) {
                if (i == 0) {
                    i = 7
                }
                let dayKey = Object.keys(json.programming[i - 1])[0]
                for (let j = 0; j < json.programming[i - 1][dayKey].length; j++) {
                    let startTime = Object.keys(json.programming[i -1][dayKey][j])[0].split("-")[0]
                    let endTime = Object.keys(json.programming[i -1][dayKey][j])[0].split("-")[1]

                    let currentDate = new Date()   

                    let startDate = new Date(currentDate.getTime());
                    startDate.setHours(startTime.split(":")[0]);
                    startDate.setMinutes(startTime.split(":")[1]);

                    let endDate = new Date(currentDate.getTime());
                    endDate.setHours(endTime.split(":")[0]);
                    endDate.setMinutes(endTime.split(":")[1]);

                    if(startDate < currentDate && endDate > currentDate) {
                        this.cover = require("@/assets/radioplayer/"+json.programming[i -1][dayKey][j][startTime+"-"+endTime][0]["cover"]+".png");
                        this.title = json.programming[i -1][dayKey][j][startTime+"-"+endTime][0]["title"];
                        this.name = json.programming[i -1][dayKey][j][startTime+"-"+endTime][0]["name"];
                        }
                    }
                }
            }
        }
    },
};
</script>

<style lang="scss" scoped>
$radioplayer__background--colour: linear-gradient(to right, #ff5000, #ffae32);
$radioplayer__text--colour: #FFFFFF;
$radioplayer__text--font: "Lato";

#radioplayer {
  display: flex;
  justify-content: center;
  width: 100%;
  position: fixed;
  z-index: 98;
  background: $radioplayer__background--colour;
  margin-bottom: env(safe-area-inset-bottom, 20px);
}

#radioplayer__data {
  width: 100%;
  height: 58px;
  display: grid;
  grid-template-columns: 67px 1fr 48px;
  align-items: center;
  max-width: 768px;

  #radioplayer__data__cover {
    height: 42px;
    width: 42px;
    border-radius: 3px;
    margin-left: 16px;
    // background-image: url("../assets/radioplayer/cover-henk.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }

  #radioplayer__data__labels {
    font-family: $radioplayer__text--font;
    color: $radioplayer__text--colour;

    #radioplayer__data__labels__title {
      font-weight: bold;
      max-width: 90vw;
    }
  }

  #radioplayer__data__button-container {
    height: 24px;
    margin-top: -4px;

    button {
      width: 24px;
      height: 24px;
      border: none;
    }

    button:focus {
      outline: 0;
    }

    .icon-play {
      background: url(../assets/radioplayer/icon-play-white.svg);
      background-repeat: no-repeat;
      background-position: center;
    }

    .icon-pause {
      background: url(../assets/radioplayer/icon-pause-white.svg);
      background-repeat: no-repeat;
      background-position: center;
    }
  }
}

/* Smartphones (portrait and landscape) ----------- */

@media only screen and (min-device-width: 320px) and (max-device-width: 599px) {
  body.when-keyboard-active #radioplayer{
    display: none;
  }
  #radioplayer {
    bottom: 56px;
    box-shadow: 0 -3px 6px -2px rgba(0, 0, 0, 0.2);
  }

  #radioplayer__data {
    grid-template-columns: 67px 1fr 48px;
    align-items: center;
    max-width: 768px;

    #radioplayer__data__cover {
      margin-left: 16px;
    }

    #radioplayer__data__labels {
      font-size: 14px;
    }
  }
}

/* Tablet (portrait) ----------- */

@media only screen and (min-device-width: 600px) and (max-device-width: 899px) {
  body.when-keyboard-active #radioplayer {
    display: none;
  }
  #radioplayer {
    bottom: 56px;
    box-shadow: 0 -3px 6px -2px rgba(0, 0, 0, 0.2);
  }

  #radioplayer__data {
    grid-template-columns: 67px 1fr 48px;
    align-items: center;
    max-width: 768px;

    #radioplayer__data__cover {
      margin-left: 16px;
    }

    #radioplayer__data__labels {
      font-size: 14px;
    }
  }
}

/* Tablet (landscape) ----------- */

@media only screen and (min-device-width: 900px) and (max-device-width: 1199px) {
  body.when-keyboard-active #radioplayer {
    display: none;
  }
  #radioplayer {
    bottom: 56px;
    box-shadow: 0 -3px 6px -2px rgba(0, 0, 0, 0.2);
  }

  #radioplayer__data {
    grid-template-columns: 67px 1fr 48px;
    align-items: center;
    max-width: 768px;

    #radioplayer__data__cover {
      margin-left: 16px;
    }

    #radioplayer__data__labels {
      font-size: 14px;
    }
  }
}

// Desktop versions start here ------------------------------------------------------------------------------------------
/* Desktop ----------- */

@media only screen and (min-device-width: 1200px) and (max-device-width: 1799px) {
  #radioplayer {
    box-shadow: 0 3px 6px -2px rgba(0, 0, 0, 0.2);
    top: 80px;
  }

  #radioplayer__data {
    grid-template-columns: 67px 1fr 48px;
    align-items: center;
    max-width: 768px;

    #radioplayer__data__cover {
      margin-left: 16px;
    }

    #radioplayer__data__labels {
      font-size: 14px;
    }
  }
}

/* Large desktop ----------- */

@media only screen and (min-device-width: 1800px) {
  #radioplayer {
    box-shadow: 0 3px 6px -2px rgba(0, 0, 0, 0.2);
    top: 80px;
  }

  #radioplayer__data {
    grid-template-columns: 67px 1fr 48px;
    align-items: center;
    max-width: 768px;

    #radioplayer__data__cover {
      margin-left: 16px;
    }

    #radioplayer__data__labels {
      font-size: 14px;
    }
  }
}
</style>

<style lang="scss">
@media only screen and (min-device-width: 1800px) {
  #app {
    padding: 138px 0px 0px 0px;
  }
}
</style>